import React from 'react';
import { DatePicker, Space } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;

function convertToUnixTimestamp(arr) {
    if (arr === null) {
        return null;
    }
    else {
        return arr.map(obj => Math.floor(obj.$d.getTime() / 1000));
    }
}

const DateRange = ({ defaultValue, disabled, onChange }) => {
    return (
        <Space direction="vertical" size={12}>
            <RangePicker
                defaultValue={defaultValue}
                disabled={disabled}
                onChange={(v) => {
                    const unixTime = convertToUnixTimestamp(v);
                    onChange(unixTime)
                }}
            />
        </Space>
    )
}

export default DateRange
